/* eslint-disable no-unused-vars */
import Icon from "@ant-design/icons";
import { Checkbox, Col, Divider, Form, Row, Typography } from "antd";
import Button from "@ui/form-controls/button";
import { useEffect, useRef } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";

import { ReactComponent as FilterIcon } from "@assets/images/svg/filter.svg";

import { detailPersonSearchClear } from "@redux/actionCreators";
import {
  clearGlobalSearch,
  getGlobalSearch
} from "@redux/actionCreators/candidateModal";

import "@assets/styles/report-pages.scss";

const { Title } = Typography;

const GlobalFilter = ({ searchString, handleFilterData, tableData }) => {
  const dispatch = useDispatch();
  const formRef = useRef();

  const globalSearchData = useSelector(
    rdc => rdc?.candidateModalReducer?.getGlobalSearch,
    shallowEqual
  );
  const { resultData = "" } = globalSearchData || "";

  const clearFieldsValue = () => {
    formRef.current.resetFields();
    handleFilterData([]);
  };

  const getFormFieldsValue = () => {
    const formValues = formRef.current?.getFieldsValue();
    handleFilterData(formValues);
  };

  useEffect(() => {
    if (searchString && searchString?.length !== 0) {
      dispatch(getGlobalSearch(searchString));
    }

    return () => {
      dispatch(clearGlobalSearch());
      dispatch(detailPersonSearchClear());
    };
  }, []);

  useEffect(() => {
    if (resultData) {
      const resultKeys = Object.keys(resultData);
      resultKeys.forEach(keys => {
        const tempObj = {};
        tempObj[keys] = resultData[keys].length !== 0;
        formRef.current.setFieldsValue(tempObj);
      });
    }
  }, [resultData]);

  useEffect(() => {
    if (tableData?.length === 0) {
      formRef.current.resetFields();
    }
  }, [tableData]);

  const resultKeys = Object.keys(resultData || {});

  return (
    <div className="global-search">
      <Form
        labelCol={{
          span: 4
        }}
        wrapperCol={{
          span: 14
        }}
        layout="horizontal"
        onValuesChange={getFormFieldsValue}
        ref={formRef}
        scrollToFirstError
      >
        <Row justify="space-between">
          <Col>
            <Icon component={FilterIcon} />
            <span>Filter</span>
          </Col>
          <Col>
            <Button variant="outline" onClick={() => clearFieldsValue()}>
              Clear Filters
            </Button>
          </Col>
        </Row>

        <Divider className="m-2"/>

        <Row className="filter-list">
          {resultData &&
            resultKeys.map(keys => (
              <>
                <Col span={24}>
                  <Title level={5}>{keys}</Title>
                  <Form.Item
                    labelCol={{ span: 24 }}
                    label=""
                    name={keys}
                    fieldKey={keys}
                    rules={[{ required: false }]}
                    wrapperCol={{
                      span: 24
                    }}
                    initialValue={false}
                    valuePropName="checked"
                  >
                    <Checkbox>{`${keys} (${resultData[keys]?.length || 0})`}</Checkbox>
                  </Form.Item>
                </Col>
                <Divider className="m-0"/>
              </>
            ))}
        </Row>
      </Form>
    </div>
  );
};
export default GlobalFilter;
